"use client"

import React from "react"

export const StatsSection: React.FC = () => (
  <div className="bg-gray-900/50 py-24 backdrop-blur-sm">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
        <div className="bg-gray-800/30 backdrop-blur-sm rounded-xl p-8 border border-gray-700/50">
          <div className="text-5xl font-bold text-blue-500 mb-2">
            <span className="bg-gradient-to-r from-blue-400 to-violet-500 text-transparent bg-clip-text">
              75ms
            </span>
          </div>
          <div className="text-gray-400 text-lg">Average Signal Generation</div>
        </div>
        <div className="bg-gray-800/30 backdrop-blur-sm rounded-xl p-8 border border-gray-700/50">
          <div className="text-5xl font-bold text-blue-500 mb-2">
            <span className="bg-gradient-to-r from-blue-400 to-violet-500 text-transparent bg-clip-text">
              $30M+
            </span>
          </div>
          <div className="text-gray-400 text-lg">Daily Trading Capacity</div>
        </div>
        <div className="bg-gray-800/30 backdrop-blur-sm rounded-xl p-8 border border-gray-700/50">
          <div className="text-5xl font-bold text-blue-500 mb-2">
            <span className="bg-gradient-to-r from-blue-400 to-violet-500 text-transparent bg-clip-text">
              99.99%
            </span>
          </div>
          <div className="text-gray-400 text-lg">System Reliability</div>
        </div>
      </div>
    </div>
  </div>
)